export function formatCurrency(value, currency) {
  if (typeof currency !== "string") {
    currency = "EUR";
  }
  return new Intl.NumberFormat("es-es", { style: "currency", currency }).format(
    value
  );
}
